import { assert_string_object_id, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestWorkspaceUserInvitationReply extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORKSPACE_USER_INVITATION_REPLY;

  workspace_id!: string;
  invitation_id!: string;
  accepted!: boolean;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_string_object_id(this.invitation_id);
    assert_type_boolean(this.accepted);
  }
}
